export default __webpack_public_path__ + "static/media/table.6f58d124.svg";